/**
 * User display label policy (DEVELOPMENT.md §"User Selectors and Labels").
 *
 * Label resolution order:
 *   1. email — always preferred when present
 *   2. name  — display name
 *   3. user_id — ONLY when it is NOT a UUID: human-readable handles of
 *      service accounts (e.g. "seed-eu-w1-sa") are meaningful usernames.
 *      Raw UUIDs must never be shown to end users.
 *   4. fallback neutral label (default: "Email no disponible")
 */

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value: string | null | undefined): boolean {
  return Boolean(value && UUID_PATTERN.test(value));
}

export function userDisplayLabel(
  email: string | null | undefined,
  name: string | null | undefined,
  userId: string | null | undefined,
  fallback = 'Email no disponible',
): string {
  if (email) return email;
  if (name) return name;
  if (userId && !isUuid(userId)) return userId;
  return fallback;
}
